import { memo, useEffect } from "react";
import { Button, ButtonTypes, SettingsLayout, toast } from "@clintonelec/react-storybook";
import { NotificationType, notify } from "src/Notifications";
import { useBlocker } from "react-router-dom";

type ActionButtonsProps = {
	disabled?: boolean;
};

function ActionButtons(props: ActionButtonsProps) {
	const { disabled } = props;
	const { reset: handleResetClick, proceed: handleProceedClick, state: blockerState } = useBlocker(!disabled);

	useEffect(() => {
		const toastContent = (
			<div className="blocker-toast-container">
				<div className="blocker-toast-content">
					Are you sure you want to leave the page? There may be unsaved changes.
				</div>
				<Button
					className="blocker-cancel-button"
					ghost
					onClick={ handleResetClick }
					type={ ButtonTypes.DANGER }
				>
					Cancel
				</Button>
				<Button
					onClick={ handleProceedClick }
					type={ ButtonTypes.TERTIARY }
				>
					Proceed
				</ Button>
			</div>
		);

		if (blockerState === "blocked") {
			if (!disabled) {
				notify(
					NotificationType.WARNING,
					"Unsaved changes",
					toastContent,
					false,
					{ toastId: "blockerToast" });
			} else {
				toast.dismiss("blockerToast");
				handleResetClick();
			}
		}
	}, [ blockerState, handleResetClick, handleProceedClick, disabled ]);

	return <SettingsLayout.ActionBar disabled={ disabled ?? false } />;
}

export default memo(ActionButtons);
